import React from 'react'

import {createBrowserRouter} from "react-router-dom";
import NavBar from "./widgets/NavBar";
import PatientList from "./components/PatientList";
import {Grid424} from "./widgets/Grids";
import {Questionnaire} from "./components/Questionnaire";
import Login from "./components/Login";
import PasswordReset from "./components/PasswordReset";
import Admin from "./components/Admin";


const loggedInScreen = () => <>
    <NavBar/>
    <div style={{marginTop: 100}}></div>
    <Grid424>
        <PatientList/>
    </Grid424>
</>


export default createBrowserRouter([
    {
        path: "/",
        element: loggedInScreen()
    },
    {
        path: "/login",
        element: <>
            <NavBar/>
            <div style={{marginTop: 100}}></div>
            <Login/>
        </>,
        //loader: async () => getLsPipelines("all"),
    },
    {
        path: "/pwreset/:guid",
        element: <>
            <NavBar/>
            <div style={{marginTop: 100}}></div>
            <PasswordReset/>
        </>
    },
    {
        path: "/dossiers",
        element: loggedInScreen()
    },
    {
        path: "/dossiers/:dossierId",
        element: <Questionnaire/>
        //loader: async ({params}) => getDossier(params.id)
    },
    {
        path: "/admin",
        element: <>
            <NavBar/>
            <div style={{marginTop: 100}}></div>
            <Admin/>
        </>,
        loader: async ({params}) => getUsers()
    }
])


